var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import styled from '@emotion/styled';
import { themeGet, position, space, display, justifyContent, alignItems, border, borderRadius, } from 'styled-system';
import { themeWidth, themeHeight } from '../../theme/system-utilities';
export var ControlButton = styled.button(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  -webkit-appearance: none;\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n\n  background-color: white;\n  box-shadow: ", ";\n  opacity: 0.9;\n  cursor: pointer;\n\n  &:hover {\n    opacity: 1;\n  }\n\n  &:active,\n  &:focus {\n    outline: none;\n  }\n\n  &:active {\n    border: 1px solid ", ";\n    box-shadow: none;\n  }\n\n  &[disabled] {\n    opacity: 0.5;\n  }\n\n  &[disabled] {\n    display: none;\n  }\n"], ["\n  -webkit-appearance: none;\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n  ", ";\n\n  background-color: white;\n  box-shadow: ",
    ";\n  opacity: 0.9;\n  cursor: pointer;\n\n  &:hover {\n    opacity: 1;\n  }\n\n  &:active,\n  &:focus {\n    outline: none;\n  }\n\n  &:active {\n    border: 1px solid ", ";\n    box-shadow: none;\n  }\n\n  &[disabled] {\n    opacity: 0.5;\n  }\n\n  &[disabled] {\n    display: none;\n  }\n"])), display, justifyContent, alignItems, themeWidth, themeHeight, space, border, borderRadius, position, function (_a) {
    var controlShadow = _a.controlShadow, props = __rest(_a, ["controlShadow"]);
    return controlShadow || "0 0 0 1px " + themeGet('colors.gray.5')(props);
}, themeGet('colors.gray.10'));
ControlButton.defaultProps = {
    display: ['none', 'flex'],
    justifyContent: 'center',
    alignItems: 'center',
    themeWidth: 6,
    arrowSize: '22px',
    themeHeight: 6,
    p: 0,
    border: 'none',
    borderRadius: '100%',
};
export default ControlButton;
var templateObject_1;
